import { render, staticRenderFns } from "./KeyTextarea.vue?vue&type=template&id=676e8239&scoped=true&"
import script from "./KeyTextarea.vue?vue&type=script&lang=js&"
export * from "./KeyTextarea.vue?vue&type=script&lang=js&"
import style0 from "./KeyTextarea.vue?vue&type=style&index=0&id=676e8239&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e8239",
  null
  
)

export default component.exports